export interface Testimonial {
  quote: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Prima passavo ore la domenica a cercare esercizi su YouTube. Ora scelgo la disciplina, apro il volume sul telefono e so esattamente cosa vado ad allenare. Ho recuperato il mio tempo libero e i miei atleti capiscono la tecnica perché c’è una vera progressione.',
    author: 'Carlos',
    role: 'Allenatore di club',
    location: 'Madrid, Spagna',
  },
  {
    quote:
      'Il Volume 6 ha trasformato il modo in cui organizzo i miei gruppi misti. Non c’è più caos in pista. So esattamente come adattare ogni sessione al livello di ogni atleta. Ora sono organizzato e loro migliorano più velocemente.',
    author: 'Mateo',
    role: 'Preparatore fisico',
    location: 'Buenos Aires, Argentina',
  },
  {
    quote:
      'Le progressioni dei salti sono incredibili. Ho una guida passo a passo per ogni disciplina. I miei atleti avanzano più rapidamente perché so cosa insegnare prima e cosa dopo. La coerenza tecnica fa tutta la differenza.',
    author: 'Lucía',
    role: 'Allenatrice di scuola',
    location: 'Città del Messico, Messico',
  },
]
